import styled from 'styled-components'

export const TextVariants = styled.div`
  margin: 0 0 30px;

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
  }

  li {
    margin: 0 8px 5px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }

  button {
    cursor: pointer;
    outline: none;
    background: ${props => props.theme.palette.general.light};
    border: 1px solid ${props => props.theme.palette.general.strong};
    margin: 0;
    transition: all ease-in-out 0.3s;
    border-radius: 4px;
    padding: 2px;
    font-size: 14px;
    color: #000;
    text-align: center;
    height: 40px;
    box-sizing: border-box;
    line-height: 1.5;

    span {
      width: 40px;
      height: 40px;
      display: block;
      border-radius: 4px;
    }

    &:hover {
      opacity: 0.7;
    }

    &.active {
      cursor: default;
      background: ${props => props.theme.palette.general.strong};
      color: ${props => props.theme.palette.general.light};

      &:hover {
        opacity: 1;
      }
    }

    &[disabled] {
      opacity: 0.4;
      cursor: not-allowed;
    }
  }
`
